/**
 * Marcador client-side (sessionStorage) de "acabei de informar o celular para
 * ativar a confirmação por SMS". No Universal Login, a ativação passa pela
 * `mfa-sms-enrollment` (telefone) e depois pela `mfa-sms-challenge` (código),
 * e o SDK não diz à segunda que ela faz parte de uma ativação. Sem marcador
 * (ou expirado, ou de outro número), a tela mostra a copy de login de hoje.
 */

const STORAGE_KEY = 'alelo_mfa_sms_enrollment'
const TTL_MS = 15 * 60 * 1000

type Marker = { startedAt: number; last4: string }

const lastDigits = (phone: string) => phone.replace(/\D/g, '').slice(-4)

function read(): Marker | null {
  try {
    const raw = window.sessionStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw) as Partial<Marker>
    return typeof parsed.startedAt === 'number' && typeof parsed.last4 === 'string'
      ? { startedAt: parsed.startedAt, last4: parsed.last4 }
      : null
  } catch {
    return null
  }
}

/** Grava o marcador com o instante atual e o final do celular informado. Chamar antes do submit real. */
export function start(phone: string): void {
  try {
    window.sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ startedAt: Date.now(), last4: lastDigits(phone) }),
    )
  } catch {
    /* sessionStorage indisponível — a tela de código segue com a copy de login */
  }
}

/**
 * True se o marcador tem no máximo 15 minutos e o celular do desafio termina
 * com os mesmos dígitos. Sem celular no desafio, não há como contradizer.
 */
export function isActiveFor(phoneNumber?: string): boolean {
  const marker = read()
  if (!marker || Date.now() - marker.startedAt > TTL_MS) return false
  const digits = phoneNumber ? phoneNumber.replace(/\D/g, '') : ''
  return !digits || digits.endsWith(marker.last4)
}

/** Remove o marcador. */
export function clear(): void {
  try {
    window.sessionStorage.removeItem(STORAGE_KEY)
  } catch {
    /* nada a limpar se sessionStorage já não está acessível */
  }
}
